import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBranchSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBranchSimple"><Path d="M18 2C20.2091 2 22 3.79086 22 6C22 8.20914 20.2091 10 18 10C16.1528 10 14.5985 8.74772 14.1387 7.0459C10.4084 7.44522 7.44522 10.4084 7.0459 14.1387C8.74772 14.5985 10 16.1528 10 18C10 20.2091 8.20914 22 6 22C3.79086 22 2 20.2091 2 18C2 16.1362 3.27477 14.57 5 14.126V2.5H7V8.99902C8.65831 6.79182 11.209 5.29566 14.1162 5.04102C14.5459 3.29508 16.1215 2 18 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBranchSimple;
